import angular from 'angular';
import './resource';

const module = angular.module('whyline.resources.tags', [
  'whyline.resources.resource',
]);

const TagsFactory = (Resource, $http, $state, API_URL) => {
  /*@ngInject*/
  //API REST Resource Name
  const _type = 'tags?organizationId';

  const _schema = {
    placeIds: [],
    tagName: String,
    organizationId: String
  };

  const Tags = function (data) {
    angular.forEach(_schema, (prop, key) => {
      this[key] = prop.default;
    });

    angular.forEach(data, (prop, key) => {
      this[key] = prop;
    });
  };

  Tags.prototype = new Resource(_type, _schema, Tags);

  Resource.Extend(_type, Tags);

  //one minute
  const validityTime = 5 * 60 * 1000;
  Tags.InitCache(validityTime);

  Tags.Save = tags => {
    const url = `${API_URL}${_type}`;
    return $http.post(url, tags)
      .then(response => {
        const item = response.data;
        Tags.UpdateCache(item._id, item);
        return item;
      });
  }

  Tags.FetchAll = () => {
    const url = `${API_URL}${_type}`;
    return $http.get(url)
      .then(response => {
        const item = response.data;
        Tags.UpdateCache(item._id, item);
        return item;
      });
  }

  return Tags;
};

module.exports = module.factory('Tags', TagsFactory);